.noResponses {
  align-self: center;
}

.responseRow {
  display: flex;
}

.avatar {
  margin-right: 16px;
}
